const honorifics = [
  'Mr',
  'Ms',
  'Mrs',
  'Miss',
  'Dr',
  'Sir',
  'Dame',
  'Lord',
  'Lady',
] as const;

export const honorificsDropdownList = honorifics.map((honorific) => ({
  value: honorific,
  label: honorific,
}));
